// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import TopMenu from '../../../../TopMenu';

// /* ── SVGs provided by user ───────────────────────────────────────────────── */
// const StudentSVG = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512">
//     <g>
//       <ellipse cx="229.3" cy="326.5" fill="#1b136a" rx="127.9" ry="98.9"/>
//       <path fill="#e6e6ff" d="M421.2 57.6c9.5 25.2 8.2 43.6 5.6 55.5-6 26.9-23.1 37.5-25.4 64.4-1.4 16.3 3.4 29.9 7.2 38.2-40.4-7.3-80.8-14.5-121.2-21.8 0 0-9.3-49.4 13.3-74.1C323.4 95 309.4 42 309.4 42z"/>
//       <path fill="#1b136a" d="M396.9 75.4c-8.5-.1-9.7.2-21.6-2.6-3.1-.7-6.3-1.8-9.5-1.7-1.9.1-3.3.7-8.9 2.8-.2-2.7-2.1-5.3-4.9-6-3-.8-6.2.7-7.6 3.4-.4.8.8 1.5 1.2.7 1.1-2.1 3.6-3.3 6-2.7 2.5.7 4 3.2 3.7 5.7 0 .5.5.9 1 .7 6.8-2.4 8.1-3.1 10.3-3 3.4.2 6.8 1.4 10.1 2.1 5.7 1.3 14.7 3.1 20.4 1.9.7-.1.5-1.3-.2-1.3z"/>
//       <path fill="#ffaa00" d="M200.2 219h53.1v81.3h-53.1z"/>
//       <path fill="#ffaa00" d="M306.4 172.3c-1.9-25.7-6.1-52.8-25.8-69.6C261 85.9 232.9 84.6 207.2 86c-9.8.5-19.8 1.5-28.9 5.4-9.9 4.3-18.3 12.8-19.7 23.5-.3 2 .1 3.8.3 5.7-9.5 22.5-14.1 47.5-14 70.1 0 9.6 1.4 19.5 6.6 27.8 13.1 20.6 55.4 40.6 100.3 31.5 16.6-3.3 34-10.5 44.9-23.9 13-15.7 11.2-33.8 9.7-53.8z"/>
//       <circle cx="196.2" cy="167.5" r="6.8" fill="#1b136a"/>
//       <circle cx="256.2" cy="166.9" r="6.8" fill="#1b136a"/>
//       <path fill="#1b136a" d="M232 181.5c-1.9-3-4.2-3.7-5.9-7.5-.7-1.5-1.1-3.3-1.3-4.9-.1-.9 0-1.7 0-2.5.1-1.4-.1-1.7-.1-2 .2-.7-.9-1-1.1-.3-.1.2-.3.3-.4.4-.2.3-.3.7-.5 1.1-.2.7-.3 1.5-.4 2.2-.4 4.1 1 8.6 4.4 12.3 1.8 2 4.4 4.3 2.3 7-2.2 2.8-5.9 2.1-8.8 3.4-.9.4-1.1 1.7 0 2.1 3.4 1.1 7.8-.1 10.3-2.5 2.6-2.4 3.3-5.9 1.5-8.8z"/>
//       <path fill="#1b136a" d="M254.4 189.1c-2.2 3.1-3.5 7-7.5 11.2-12.5 13.1-31.6 11.4-42.8-.9-1.8-2-3.2-4.3-4.7-6.5-.6-1-2.3-.4-2 .8 1.4 4.8 5.1 9.2 9 12.3 13.5 10.8 30.7 8.8 41.9-1.8 3.7-3.5 8.2-9.5 8-14.6 0-1-1.3-1.3-1.9-.5z"/>
//       <ellipse cx="173.3" cy="183.7" fill="#ff6a00" rx="13" ry="9.4"/>
//       <ellipse cx="276" cy="183.7" fill="#ff6a00" rx="13" ry="9.4"/>
//       <path fill="#1b136a" d="M310.8 155.8c-4.9 3.2-9.2 4.2-12.5 4.3-17.5.8-36.2-19.7-45.9-51.3 0 0-11.7 4.5-19.4 21.8s-60.2 4.2-66 8-5.1 27.2-31.7 11.9c0 0-3.5-11.6-3-25.8 0 0 2.2-23.5 21.1-42.1 22.5-22.2 68.4-23.8 112.1-.8 22.4-3.4 43.2 2.9 52.2 17.2 4.8 7.7 5.2 16.1 5.8 27.6.6 13.7.2 33.7-12.7 29.2z"/>
//       <circle cx="142.4" cy="166.9" r="17.8" fill="#ffaa00"/>
//       <circle cx="311.3" cy="166.9" r="17.8" fill="#ffaa00"/>
//       <path fill="#4a53e2" d="M203.7 277.3c-11 .7-70.6 5.9-107.2 55.1C82.6 351 77.4 370 75 379.1c-4.7 18.1-14.5 55.4 2.4 76.8 15.8 20 45.8 14.6 127.5 12.7 129.3-3 150.4 8.1 169.2-12.7 27.3-30.2 14.4-88.8-11.9-123.6-13.9-18.4-30.6-29.3-41.8-35.3-11.1-5.9-28.7-13.1-44.6-16.5-4.9-1.1-9.1-1.6-44.9-2.7-16.6-.3-24.9-.7-27.2-.5z"/>
//       <path fill="#e6e6ff" d="M200.2 256.6s-5.7-2.9-8.4 4.6c-3.7 10.3-11 12.3-11.8 20.2-.2 1.9-.1 4.6 7.7 17.6 9.5 15.7 14.2 23.5 18.9 23.3 6.2-.3 11.1-9.6 15.5-17.9 5.9-11.1 5.5-16.9 8.5-17.5 7.3-1.3 13.9 32.3 25.4 32.3 5 0 9-7.2 17-21.6 7.3-13.1 5.8-17.2 5.1-18.7-1.8-3.9-5.1-2.9-9.5-9.3-6.4-9.2-6.8-12.9-10-14.2-.5-.2-2.4-.4-6.3.5-2.2.5-14.5 19.8-20.6 19.9s-31.5-19.2-31.5-19.2z"/>
//     </g>
//   </svg>
// );

// const FresherSVG = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 16.933 16.933">
//     <g>
//       <path fill="#5299d3" d="M2.117 15.731v.408c0 .146.117.265.263.265h12.173c.146 0 .264-.12.263-.265v-.408c0-2.172-1.628-3.954-3.705-4.083H5.822c-2.076.129-3.705 1.91-3.705 4.083z"/>
//       <path fill="#ffccaa" d="M7.145 9.922a.265.265 0 0 0-.267.263v2.501c.001.146.12.264.267.264h2.644a.265.265 0 0 0 .266-.264v-2.5a.265.265 0 0 0-.266-.264z"/>
//       <path fill="#ffb889" d="M7.145 9.922a.265.265 0 0 0-.266.263v.765a2.694 2.694 0 0 0 3.176 0v-.765a.265.265 0 0 0-.266-.263z"/>
//       <path fill="#3385c8" d="M5.822 11.648c-2.076.129-3.705 1.911-3.705 4.083v.408c0 .146.117.265.263.265h.53a.265.265 0 0 1-.264-.265v-.408c0-2.172 1.63-3.954 3.706-4.083h-.53z"/>
//       <path fill="#a0c7e7" d="m6.427 10.926-.795.793a.265.265 0 0 0 0 .373l1.854 1.851c.103.103.27.103.373 0l.608-.605.607.605c.103.103.27.103.373 0l1.852-1.851a.265.265 0 0 0 0-.373l-.793-.793a.265.265 0 0 0-.375 0L8.467 12.59 6.8 10.926a.265.265 0 0 0-.189-.078.265.265 0 0 0-.184.078z"/>
//       <path fill="#5299d3" d="m8.334.562-6.88 3.661a.234.234 0 0 0 .014.428l3.994 1.83.119-.218h5.77l.118.219 3.996-1.831a.234.234 0 0 0 .014-.428L8.599.563a.287.287 0 0 0-.266 0z"/>
//       <path fill="#ffb889" d="M5.86 7.087c-.553 0-.987.478-.987 1.04 0 .56.434 1.04.986 1.04a.913.913 0 0 0 .227-.032V7.116a.938.938 0 0 0-.227-.029z"/>
//       <path fill="#ffccaa" d="M12.061 8.127c0 .56-.434 1.04-.986 1.04a.913.913 0 0 1-.227-.032V7.116a.938.938 0 0 1 .227-.029c.552 0 .986.478.986 1.04z"/>
//       <path fill="#356287" d="M8.467 4.462c-.823 0-1.565.074-2.121.205-.278.066-.51.143-.694.248-.182.104-.354.264-.357.502-.016.078-.198 1.039.543 1.778l.078.078h5.101l.077-.078c.74-.74.56-1.7.545-1.778-.004-.238-.176-.398-.358-.502a2.613 2.613 0 0 0-.693-.248c-.556-.131-1.299-.205-2.121-.205z"/>
//       <path fill="#2c5170" d="M6.346 4.667c-.278.066-.51.143-.694.248-.181.104-.354.264-.358.502-.015.078-.197 1.039.544 1.778l.078.078h.53l-.079-.078c-.74-.739-.559-1.7-.544-1.778.004-.238.177-.398.359-.502.183-.105.415-.182.693-.248.495-.117 1.141-.185 1.856-.2-.088-.001-.174-.005-.264-.005-.823 0-1.565.074-2.121.205z"/>
//       <path fill="#ffccaa" d="M7.812 5.316a.265.265 0 0 0-.267.262 1.075 1.075 0 0 1-1.076 1.068h-.444a.265.265 0 0 0-.263.264v1.328c0 1.492 1.21 2.7 2.705 2.7a2.702 2.702 0 0 0 2.705-2.7V6.91a.265.265 0 0 0-.264-.264H9.353c-.643 0-1.185-.47-1.283-1.106a.265.265 0 0 0-.258-.224z"/>
//       <path fill="#eeeeee" d="m3.44 3.167-.53.282v3.694h.53z"/>
//       <path fill="#ffca28" d="M2.911 6.614a.265.265 0 0 0-.265.264v2.389c0 .147.119.266.265.265h.529c.146 0 .264-.119.263-.265v-2.39a.265.265 0 0 0-.263-.263z"/>
//       <path fill="#a0c7e7" d="M8.467 2.91c-.823 0-1.565.076-2.12.202a2.746 2.746 0 0 0-.69.237.858.858 0 0 0-.24.182.477.477 0 0 0-.126.31v1.55c0 .008.003.015.004.023v.003c-.008.036-.05.266-.02.571.2-.196.299-.301.472-.422.146-.102.36-.24.827-.363.32-.085.728-.154 1.202-.19.222-.013.45-.021.69-.021s.47.008.691.02c.475.037.882.106 1.202.191.466.123.681.261.827.363.173.12.272.226.473.422a2.065 2.065 0 0 0-.02-.57l-.001-.004c0-.008.004-.015.004-.024V3.841a.477.477 0 0 0-.126-.31.858.858 0 0 0-.24-.182 2.745 2.745 0 0 0-.69-.237c-.555-.126-1.297-.201-2.12-.201z"/>
//       <g fill="#3385c8">
//         <path d="M4.774 14.818a.265.265 0 0 0-.275.286v1.297h.527v-1.297a.265.265 0 0 0-.252-.286z"/>
//         <path d="M12.183 14.818a.265.265 0 0 0-.276.286v1.297h.527v-1.297a.265.265 0 0 0-.251-.286z"/>
//       </g>
//     </g>
//   </svg>
// );

// const ExperiencedSVG = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 173.397 173.397" fillRule="evenodd">
//     <g>
//       <path fill="#555768" d="M62.765 99.94h48.875l13.355 1.694c14.668 1.86 23.496 15.485 23.496 30.27v22.114c0 4.697-3.845 8.542-8.543 8.542H33.45c-4.697 0-8.542-3.844-8.542-8.543v-22.114c0-14.785 8.812-28.538 23.496-30.269l14.363-1.693z"/>
//       <path fill="#e6e6e6" d="M86.699 152.852a59.198 59.198 0 0 1-24.942-52.911h49.883A59.198 59.198 0 0 1 86.7 152.852z"/>
//       <path fill="#fdc28c" d="M70.09 92.816c1.508 4.566 10.938 13.979 16.609 16.542 5.67-2.563 15.1-11.976 16.609-16.542V77.559H70.089z"/>
//       <path fill="#f2a568" d="M103.308 84.638V77.56H70.09v7.08c9.272 9.915 23.945 9.916 33.218 0z"/>
//       <path fill="#ab6a46" d="m114.772 51.606-57.406.835C43.904 10.78 94.638 3.762 100.51 16.7c14.814 1.052 24.557 17.845 14.262 34.905z"/>
//       <path fill="#fdc28c" d="M106.92 67.592c11.398 2.628 16.706-18.87 2.832-16.304-.003-5.74-1.556-10.926-4.659-14.378a5.892 5.892 0 0 0-7.635-1.009c-5.655 3.672-15.988 6.532-26.262 4.195a5.903 5.903 0 0 0-6.892 3.776c-.752 2.094-.835 4.391-.66 7.416-13.874-2.567-8.566 18.932 2.832 16.304 5.141 27.025 35.303 27.025 40.444 0z"/>
//       <path fill="#41434d" fillRule="nonzero" d="M134.626 138.25a1.693 1.693 0 0 0 0-3.387h-17.248a1.693 1.693 0 0 0 0 3.387z"/>
//       <path fill="#e35454" d="m82.89 122.69-6.196 21.267c1.424 5.242 4.724 8.292 10.005 8.895 5.68-1.213 9.877-3.604 10.004-8.895l-6.196-21.267 4.725-7.863c.715-4.591-1.86-7.663-8.533-8.855-5.664 2.23-8.283 5.2-8.534 8.855z"/>
//       <path fill="#c8c8c8" d="M86.699 105.972c-5.671-2.564-13.408-8.59-16.61-13.156l-8.332 7.125 12.327 22.934c2.13-6.235 6.206-11.907 12.615-16.903z"/>
//       <path fill="#c8c8c8" d="M86.699 105.972c5.67-2.564 13.407-8.59 16.609-13.156l8.332 7.125-12.327 22.934c-2.13-6.235-6.206-11.907-12.614-16.903z"/>
//       <path fill="#555768" d="M67.913 136.569h3.143A59.14 59.14 0 0 0 86.7 152.852a59.14 59.14 0 0 0 15.642-16.283h3.143v18.52h-37.57z"/>
//       <path fill="#41434d" d="M88.392 162.56h-3.387v-10.946l1.694 1.238 1.693-1.238z"/>
//     </g>
//   </svg>
// );

// /* ── Data ─────────────────────────────────────────────────────────────────── */
// const OPTIONS = [
//   {
//     id:      'student',
//     tag:     'ACADEMIC',
//     icon:    <StudentSVG />,
//     label:   'Student',
//     sub:     'Currently enrolled',
//     desc:    'Build a strong CV highlighting projects, skills and education.',
//     accent:  '#8b5cf6',
//     accentD: '#A78BFA',
//   },
//   {
//     id:      'fresher',
//     tag:     'ENTRY LEVEL',
//     icon:    <FresherSVG />,
//     label:   'Fresher',
//     sub:     '0–1 year experience',
//     desc:    'Craft a compelling first-job resume that gets past ATS filters.',
//     accent:  '#00C9A7',
//     accentD: '#00FFD1',
//   },
//   {
//     id:      'experienced',
//     tag:     'PRO',
//     icon:    <ExperiencedSVG />,
//     label:   'Experienced',
//     sub:     '1+ years in field',
//     desc:    'Showcase your career growth with a results-driven professional resume.',
//     accent:  '#0A66C2',
//     accentD: '#4D9FFF',
//   },
// ];

// /* ── Styles ──────────────────────────────────────────────────────────────── */
// const CSS = `
// @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600;700&display=swap');

// .exp-shell { min-height:100vh; font-family:'DM Sans',sans-serif; -webkit-font-smoothing:antialiased; position:relative; overflow:hidden; }
// .exp-shell.light { background:#F5F4F8; color:#1A1828; }
// .exp-shell.dark  { background:#050508; color:#E8E6F0; }

// .exp-orb { position:absolute; border-radius:50%; pointer-events:none; }
// .exp-orb-1 { width:600px; height:600px; top:-200px; left:-200px;   background:radial-gradient(circle, rgba(139,92,246,0.09) 0%, transparent 65%); }
// .exp-orb-2 { width:500px; height:500px; bottom:-150px; right:-100px; background:radial-gradient(circle, rgba(0,201,167,0.08) 0%, transparent 65%); }

// .exp-grid {
//   position:absolute; inset:0; pointer-events:none; background-size:40px 40px;
//   mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
//   -webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
// }
// .exp-shell.dark  .exp-grid { background-image:linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px); }
// .exp-shell.light .exp-grid { background-image:linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px); }

// .exp-page {
//   position:relative; z-index:1;
//   min-height:calc(100vh - 64px); margin-top:64px;
//   padding:64px 24px 80px;
//   display:flex; flex-direction:column; align-items:center; gap:44px;
// }

// .exp-header { text-align:center; max-width:600px; }

// .exp-badge {
//   display:inline-flex; align-items:center; gap:7px;
//   font-size:11px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase;
//   padding:6px 14px; border-radius:100px; margin-bottom:20px;
// }
// .exp-shell.dark  .exp-badge { background:rgba(139,92,246,0.12); border:1px solid rgba(139,92,246,0.3); color:#A78BFA; }
// .exp-shell.light .exp-badge { background:rgba(139,92,246,0.08); border:1px solid rgba(139,92,246,0.2); color:#7C3AED; }

// .exp-title {
//   font-family:'Syne',sans-serif;
//   font-size:clamp(26px,4vw,42px); font-weight:800; letter-spacing:-0.04em; line-height:1.1;
//   margin-bottom:14px;
// }
// .exp-shell.dark  .exp-title { color:#F0EEF8; }
// .exp-shell.light .exp-title { color:#1A1828; }
// .exp-title span {
//   background:linear-gradient(135deg,#A78BFA,#00FFD1);
//   -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent;
// }
// .exp-shell.light .exp-title span {
//   background:linear-gradient(135deg,#7C3AED,#00C9A7);
//   -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent;
// }
// .exp-sub { font-size:15px; line-height:1.7; }
// .exp-shell.dark  .exp-sub { color:#6E6B80; }
// .exp-shell.light .exp-sub { color:#8B879E; }

// /* Cards */
// .exp-cards { display:grid; grid-template-columns:repeat(3,1fr); gap:20px; width:100%; max-width:900px; }
// @media(max-width:700px){ .exp-cards{ grid-template-columns:1fr; max-width:400px; } }

// .exp-card {
//   border-radius:20px; padding:28px 22px 22px; cursor:pointer; position:relative;
//   overflow:hidden; border:1.5px solid; text-align:left; background:none;
//   display:flex; flex-direction:column; transition:transform 0.22s, box-shadow 0.22s, border-color 0.22s;
// }
// .exp-shell.dark  .exp-card { background:#0D0D12; border-color:rgba(255,255,255,0.06); }
// .exp-shell.light .exp-card { background:#FFFFFF; border-color:rgba(0,0,0,0.08); box-shadow:0 2px 16px rgba(0,0,0,0.05); }

// .exp-card:hover { transform:translateY(-6px); }
// .exp-shell.dark  .exp-card:hover  { border-color:var(--ac-d); box-shadow:0 12px 40px color-mix(in srgb, var(--ac-d) 18%, transparent); }
// .exp-shell.light .exp-card:hover  { border-color:var(--ac);   box-shadow:0 12px 40px color-mix(in srgb, var(--ac)   15%, transparent); }
// .exp-shell.dark  .exp-card.active { border-color:var(--ac-d); box-shadow:0 0 0 3px color-mix(in srgb, var(--ac-d) 18%, transparent); transform:translateY(-6px); }
// .exp-shell.light .exp-card.active { border-color:var(--ac);   box-shadow:0 0 0 3px color-mix(in srgb, var(--ac)   15%, transparent); transform:translateY(-6px); }

// .exp-glow {
//   position:absolute; inset:0; border-radius:20px; pointer-events:none; opacity:0;
//   transition:opacity 0.35s;
//   background:radial-gradient(ellipse at 50% 0%, var(--glow,transparent), transparent 70%);
// }
// .exp-card:hover .exp-glow, .exp-card.active .exp-glow { opacity:1; }

// .exp-card-top { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:16px; }

// .exp-card-icon { transition:transform 0.25s; flex-shrink:0; }
// .exp-card:hover .exp-card-icon { transform:scale(1.08) translateY(-2px); }

// .exp-card-tag {
//   font-size:10px; font-weight:700; letter-spacing:0.1em; padding:4px 10px; border-radius:100px;
//   align-self:flex-start; margin-top:4px;
// }
// .exp-shell.dark  .exp-card-tag { color:var(--ac-d); background:color-mix(in srgb, var(--ac-d) 12%, transparent); border:1px solid color-mix(in srgb, var(--ac-d) 30%, transparent); }
// .exp-shell.light .exp-card-tag { color:var(--ac);   background:color-mix(in srgb, var(--ac)   10%, transparent); border:1px solid color-mix(in srgb, var(--ac)   25%, transparent); }

// .exp-card-name {
//   font-family:'Syne',sans-serif; font-size:20px; font-weight:800;
//   letter-spacing:-0.02em; margin-bottom:4px;
// }
// .exp-shell.dark  .exp-card-name { color:#EDEAF5; }
// .exp-shell.light .exp-card-name { color:#1A1828; }

// .exp-card-sub { font-size:12px; font-weight:500; margin-bottom:12px; }
// .exp-shell.dark  .exp-card-sub { color:#4A4760; }
// .exp-shell.light .exp-card-sub { color:#B0ACC4; }

// .exp-divider { height:1px; margin-bottom:14px; }
// .exp-shell.dark  .exp-divider { background:rgba(255,255,255,0.06); }
// .exp-shell.light .exp-divider { background:rgba(0,0,0,0.06); }

// .exp-card-desc { font-size:13px; line-height:1.65; margin-bottom:20px; flex:1; }
// .exp-shell.dark  .exp-card-desc { color:#6E6B80; }
// .exp-shell.light .exp-card-desc { color:#8B879E; }

// .exp-card-cta {
//   width:100%; padding:11px 0; border-radius:10px; border:none;
//   font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700;
//   cursor:pointer; transition:filter 0.2s, transform 0.15s;
// }
// .exp-shell.dark  .exp-card-cta { background:var(--ac-d); color:#050508; }
// .exp-shell.light .exp-card-cta { background:var(--ac);   color:#fff; }
// .exp-card-cta:hover { filter:brightness(1.08); transform:translateY(-1px); }

// .exp-check {
//   position:absolute; top:14px; right:14px; width:22px; height:22px; border-radius:50%;
//   display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:800;
// }
// .exp-shell.dark  .exp-check { background:var(--ac-d); color:#050508; }
// .exp-shell.light .exp-check { background:var(--ac);   color:#fff; }

// .exp-progress { display:flex; gap:8px; }
// .exp-seg { height:5px; width:72px; border-radius:100px; transition:background 0.3s; }
// .exp-shell.dark  .exp-seg     { background:rgba(255,255,255,0.1); }
// .exp-shell.light .exp-seg     { background:#E5E7EB; }
// .exp-seg.on { background:#A78BFA; }
// .exp-shell.light .exp-seg.on  { background:#7C3AED; }
// `;

// /* ── Component ───────────────────────────────────────────────────────────── */
// const StepExperienceLevel = ({ onSelect, onBack, theme, toggleTheme }) => {
//   const [selected, setSelected] = useState(null);
//   const isDark = (theme || 'dark') === 'dark';

//   return (
//     <>
//       <style>{CSS}</style>
//       <div className={`exp-shell ${theme || 'dark'}`}>
//         <div className="exp-orb exp-orb-1" />
//         <div className="exp-orb exp-orb-2" />
//         <div className="exp-grid" />

//         <TopMenu theme={theme} toggleTheme={toggleTheme} />

//         <div className="exp-page">

//           <motion.div className="exp-header"
//             initial={{ opacity:0, y:24 }} animate={{ opacity:1, y:0 }}
//             transition={{ duration:0.55, ease:[0.22,1,0.36,1] }}>
//             <div className="exp-badge">✦ STEP 1 OF 3</div>
//             <h1 className="exp-title">What's your<br /><span>experience level?</span></h1>
//             <p className="exp-sub">We'll tailor your resume sections to fit your background perfectly.</p>
//           </motion.div>

//           <div className="exp-cards">
//             {OPTIONS.map((opt, i) => (
//               <motion.div
//                 key={opt.id}
//                 className={`exp-card ${selected === opt.id ? 'active' : ''}`}
//                 style={{
//                   '--ac':   opt.accent,
//                   '--ac-d': opt.accentD,
//                   '--glow': isDark
//                     ? `color-mix(in srgb, ${opt.accentD} 18%, transparent)`
//                     : `color-mix(in srgb, ${opt.accent}  12%, transparent)`,
//                 }}
//                 initial={{ opacity:0, y:32 }}
//                 animate={{ opacity:1, y:0 }}
//                 transition={{ delay:0.12 + i * 0.1, duration:0.5, ease:[0.22,1,0.36,1] }}
//                 whileTap={{ scale:0.985 }}
//                 onClick={() => setSelected(opt.id)}
//               >
//                 <div className="exp-glow" />

//                 <div className="exp-card-top">
//                   <div className="exp-card-icon">{opt.icon}</div>
//                   <span className="exp-card-tag">{opt.tag}</span>
//                 </div>

//                 <div className="exp-card-name">{opt.label}</div>
//                 <div className="exp-card-sub">{opt.sub}</div>
//                 <div className="exp-divider" />
//                 <p className="exp-card-desc">{opt.desc}</p>

//                 <button
//                   className="exp-card-cta"
//                   onClick={e => { e.stopPropagation(); setSelected(opt.id); onSelect(opt.id); }}
//                 >
//                   Select {opt.label} →
//                 </button>

//                 {selected === opt.id && (
//                   <motion.div
//                     className="exp-check"
//                     initial={{ scale:0 }} animate={{ scale:1 }}
//                     transition={{ type:'spring', stiffness:420, damping:22 }}>
//                     ✓
//                   </motion.div>
//                 )}
//               </motion.div>
//             ))}
//           </div>

//           <div className="exp-progress">
//             <div className="exp-seg on" />
//             <div className="exp-seg" />
//             <div className="exp-seg" />
//           </div>

//         </div>
//       </div>
//     </>
//   );
// };

// export default StepExperienceLevel;

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import TopMenu from '../../../../TopMenu';

/* ── SVGs provided by user ───────────────────────────────────────────────── */
const StudentSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 512 512">
    <g>
      <ellipse cx="229.3" cy="326.5" fill="#1b136a" rx="127.9" ry="98.9"/>
      <path fill="#e6e6ff" d="M421.2 57.6c9.5 25.2 8.2 43.6 5.6 55.5-6 26.9-23.1 37.5-25.4 64.4-1.4 16.3 3.4 29.9 7.2 38.2-40.4-7.3-80.8-14.5-121.2-21.8 0 0-9.3-49.4 13.3-74.1C323.4 95 309.4 42 309.4 42z"/>
      <path fill="#1b136a" d="M396.9 75.4c-8.5-.1-9.7.2-21.6-2.6-3.1-.7-6.3-1.8-9.5-1.7-1.9.1-3.3.7-8.9 2.8-.2-2.7-2.1-5.3-4.9-6-3-.8-6.2.7-7.6 3.4-.4.8.8 1.5 1.2.7 1.1-2.1 3.6-3.3 6-2.7 2.5.7 4 3.2 3.7 5.7 0 .5.5.9 1 .7 6.8-2.4 8.1-3.1 10.3-3 3.4.2 6.8 1.4 10.1 2.1 5.7 1.3 14.7 3.1 20.4 1.9.7-.1.5-1.3-.2-1.3z"/>
      <path fill="#ffaa00" d="M200.2 219h53.1v81.3h-53.1z"/>
      <path fill="#ffaa00" d="M306.4 172.3c-1.9-25.7-6.1-52.8-25.8-69.6C261 85.9 232.9 84.6 207.2 86c-9.8.5-19.8 1.5-28.9 5.4-9.9 4.3-18.3 12.8-19.7 23.5-.3 2 .1 3.8.3 5.7-9.5 22.5-14.1 47.5-14 70.1 0 9.6 1.4 19.5 6.6 27.8 13.1 20.6 55.4 40.6 100.3 31.5 16.6-3.3 34-10.5 44.9-23.9 13-15.7 11.2-33.8 9.7-53.8z"/>
      <circle cx="196.2" cy="167.5" r="6.8" fill="#1b136a"/>
      <circle cx="256.2" cy="166.9" r="6.8" fill="#1b136a"/>
      <path fill="#1b136a" d="M232 181.5c-1.9-3-4.2-3.7-5.9-7.5-.7-1.5-1.1-3.3-1.3-4.9-.1-.9 0-1.7 0-2.5.1-1.4-.1-1.7-.1-2 .2-.7-.9-1-1.1-.3-.1.2-.3.3-.4.4-.2.3-.3.7-.5 1.1-.2.7-.3 1.5-.4 2.2-.4 4.1 1 8.6 4.4 12.3 1.8 2 4.4 4.3 2.3 7-2.2 2.8-5.9 2.1-8.8 3.4-.9.4-1.1 1.7 0 2.1 3.4 1.1 7.8-.1 10.3-2.5 2.6-2.4 3.3-5.9 1.5-8.8z"/>
      <path fill="#1b136a" d="M254.4 189.1c-2.2 3.1-3.5 7-7.5 11.2-12.5 13.1-31.6 11.4-42.8-.9-1.8-2-3.2-4.3-4.7-6.5-.6-1-2.3-.4-2 .8 1.4 4.8 5.1 9.2 9 12.3 13.5 10.8 30.7 8.8 41.9-1.8 3.7-3.5 8.2-9.5 8-14.6 0-1-1.3-1.3-1.9-.5z"/>
      <ellipse cx="173.3" cy="183.7" fill="#ff6a00" rx="13" ry="9.4"/>
      <ellipse cx="276" cy="183.7" fill="#ff6a00" rx="13" ry="9.4"/>
      <path fill="#1b136a" d="M310.8 155.8c-4.9 3.2-9.2 4.2-12.5 4.3-17.5.8-36.2-19.7-45.9-51.3 0 0-11.7 4.5-19.4 21.8s-60.2 4.2-66 8-5.1 27.2-31.7 11.9c0 0-3.5-11.6-3-25.8 0 0 2.2-23.5 21.1-42.1 22.5-22.2 68.4-23.8 112.1-.8 22.4-3.4 43.2 2.9 52.2 17.2 4.8 7.7 5.2 16.1 5.8 27.6.6 13.7.2 33.7-12.7 29.2z"/>
      <circle cx="142.4" cy="166.9" r="17.8" fill="#ffaa00"/>
      <circle cx="311.3" cy="166.9" r="17.8" fill="#ffaa00"/>
      <path fill="#4a53e2" d="M203.7 277.3c-11 .7-70.6 5.9-107.2 55.1C82.6 351 77.4 370 75 379.1c-4.7 18.1-14.5 55.4 2.4 76.8 15.8 20 45.8 14.6 127.5 12.7 129.3-3 150.4 8.1 169.2-12.7 27.3-30.2 14.4-88.8-11.9-123.6-13.9-18.4-30.6-29.3-41.8-35.3-11.1-5.9-28.7-13.1-44.6-16.5-4.9-1.1-9.1-1.6-44.9-2.7-16.6-.3-24.9-.7-27.2-.5z"/>
      <path fill="#e6e6ff" d="M200.2 256.6s-5.7-2.9-8.4 4.6c-3.7 10.3-11 12.3-11.8 20.2-.2 1.9-.1 4.6 7.7 17.6 9.5 15.7 14.2 23.5 18.9 23.3 6.2-.3 11.1-9.6 15.5-17.9 5.9-11.1 5.5-16.9 8.5-17.5 7.3-1.3 13.9 32.3 25.4 32.3 5 0 9-7.2 17-21.6 7.3-13.1 5.8-17.2 5.1-18.7-1.8-3.9-5.1-2.9-9.5-9.3-6.4-9.2-6.8-12.9-10-14.2-.5-.2-2.4-.4-6.3.5-2.2.5-14.5 19.8-20.6 19.9s-31.5-19.2-31.5-19.2z"/>
    </g>
  </svg>
);

const FresherSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 16.933 16.933">
    <g>
      <path fill="#5299d3" d="M2.117 15.731v.408c0 .146.117.265.263.265h12.173c.146 0 .264-.12.263-.265v-.408c0-2.172-1.628-3.954-3.705-4.083H5.822c-2.076.129-3.705 1.91-3.705 4.083z"/>
      <path fill="#ffccaa" d="M7.145 9.922a.265.265 0 0 0-.267.263v2.501c.001.146.12.264.267.264h2.644a.265.265 0 0 0 .266-.264v-2.5a.265.265 0 0 0-.266-.264z"/>
      <path fill="#ffb889" d="M7.145 9.922a.265.265 0 0 0-.266.263v.765a2.694 2.694 0 0 0 3.176 0v-.765a.265.265 0 0 0-.266-.263z"/>
      <path fill="#3385c8" d="M5.822 11.648c-2.076.129-3.705 1.911-3.705 4.083v.408c0 .146.117.265.263.265h.53a.265.265 0 0 1-.264-.265v-.408c0-2.172 1.63-3.954 3.706-4.083h-.53z"/>
      <path fill="#a0c7e7" d="m6.427 10.926-.795.793a.265.265 0 0 0 0 .373l1.854 1.851c.103.103.27.103.373 0l.608-.605.607.605c.103.103.27.103.373 0l1.852-1.851a.265.265 0 0 0 0-.373l-.793-.793a.265.265 0 0 0-.375 0L8.467 12.59 6.8 10.926a.265.265 0 0 0-.189-.078.265.265 0 0 0-.184.078z"/>
      <path fill="#5299d3" d="m8.334.562-6.88 3.661a.234.234 0 0 0 .014.428l3.994 1.83.119-.218h5.77l.118.219 3.996-1.831a.234.234 0 0 0 .014-.428L8.599.563a.287.287 0 0 0-.266 0z"/>
      <path fill="#ffb889" d="M5.86 7.087c-.553 0-.987.478-.987 1.04 0 .56.434 1.04.986 1.04a.913.913 0 0 0 .227-.032V7.116a.938.938 0 0 0-.227-.029z"/>
      <path fill="#ffccaa" d="M12.061 8.127c0 .56-.434 1.04-.986 1.04a.913.913 0 0 1-.227-.032V7.116a.938.938 0 0 1 .227-.029c.552 0 .986.478.986 1.04z"/>
      <path fill="#356287" d="M8.467 4.462c-.823 0-1.565.074-2.121.205-.278.066-.51.143-.694.248-.182.104-.354.264-.357.502-.016.078-.198 1.039.543 1.778l.078.078h5.101l.077-.078c.74-.74.56-1.7.545-1.778-.004-.238-.176-.398-.358-.502a2.613 2.613 0 0 0-.693-.248c-.556-.131-1.299-.205-2.121-.205z"/>
      <path fill="#2c5170" d="M6.346 4.667c-.278.066-.51.143-.694.248-.181.104-.354.264-.358.502-.015.078-.197 1.039.544 1.778l.078.078h.53l-.079-.078c-.74-.739-.559-1.7-.544-1.778.004-.238.177-.398.359-.502.183-.105.415-.182.693-.248.495-.117 1.141-.185 1.856-.2-.088-.001-.174-.005-.264-.005-.823 0-1.565.074-2.121.205z"/>
      <path fill="#ffccaa" d="M7.812 5.316a.265.265 0 0 0-.267.262 1.075 1.075 0 0 1-1.076 1.068h-.444a.265.265 0 0 0-.263.264v1.328c0 1.492 1.21 2.7 2.705 2.7a2.702 2.702 0 0 0 2.705-2.7V6.91a.265.265 0 0 0-.264-.264H9.353c-.643 0-1.185-.47-1.283-1.106a.265.265 0 0 0-.258-.224z"/>
      <path fill="#eeeeee" d="m3.44 3.167-.53.282v3.694h.53z"/>
      <path fill="#ffca28" d="M2.911 6.614a.265.265 0 0 0-.265.264v2.389c0 .147.119.266.265.265h.529c.146 0 .264-.119.263-.265v-2.39a.265.265 0 0 0-.263-.263z"/>
      <path fill="#a0c7e7" d="M8.467 2.91c-.823 0-1.565.076-2.12.202a2.746 2.746 0 0 0-.69.237.858.858 0 0 0-.24.182.477.477 0 0 0-.126.31v1.55c0 .008.003.015.004.023v.003c-.008.036-.05.266-.02.571.2-.196.299-.301.472-.422.146-.102.36-.24.827-.363.32-.085.728-.154 1.202-.19.222-.013.45-.021.69-.021s.47.008.691.02c.475.037.882.106 1.202.191.466.123.681.261.827.363.173.12.272.226.473.422a2.065 2.065 0 0 0-.02-.57l-.001-.004c0-.008.004-.015.004-.024V3.841a.477.477 0 0 0-.126-.31.858.858 0 0 0-.24-.182 2.745 2.745 0 0 0-.69-.237c-.555-.126-1.297-.201-2.12-.201z"/>
      <g fill="#3385c8">
        <path d="M4.774 14.818a.265.265 0 0 0-.275.286v1.297h.527v-1.297a.265.265 0 0 0-.252-.286z"/>
        <path d="M12.183 14.818a.265.265 0 0 0-.276.286v1.297h.527v-1.297a.265.265 0 0 0-.251-.286z"/>
      </g>
    </g>
  </svg>
);

const ExperiencedSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 173.397 173.397" fillRule="evenodd">
    <g>
      <path fill="#555768" d="M62.765 99.94h48.875l13.355 1.694c14.668 1.86 23.496 15.485 23.496 30.27v22.114c0 4.697-3.845 8.542-8.543 8.542H33.45c-4.697 0-8.542-3.844-8.542-8.543v-22.114c0-14.785 8.812-28.538 23.496-30.269l14.363-1.693z"/>
      <path fill="#e6e6e6" d="M86.699 152.852a59.198 59.198 0 0 1-24.942-52.911h49.883A59.198 59.198 0 0 1 86.7 152.852z"/>
      <path fill="#fdc28c" d="M70.09 92.816c1.508 4.566 10.938 13.979 16.609 16.542 5.67-2.563 15.1-11.976 16.609-16.542V77.559H70.089z"/>
      <path fill="#f2a568" d="M103.308 84.638V77.56H70.09v7.08c9.272 9.915 23.945 9.916 33.218 0z"/>
      <path fill="#ab6a46" d="m114.772 51.606-57.406.835C43.904 10.78 94.638 3.762 100.51 16.7c14.814 1.052 24.557 17.845 14.262 34.905z"/>
      <path fill="#fdc28c" d="M106.92 67.592c11.398 2.628 16.706-18.87 2.832-16.304-.003-5.74-1.556-10.926-4.659-14.378a5.892 5.892 0 0 0-7.635-1.009c-5.655 3.672-15.988 6.532-26.262 4.195a5.903 5.903 0 0 0-6.892 3.776c-.752 2.094-.835 4.391-.66 7.416-13.874-2.567-8.566 18.932 2.832 16.304 5.141 27.025 35.303 27.025 40.444 0z"/>
      <path fill="#41434d" fillRule="nonzero" d="M134.626 138.25a1.693 1.693 0 0 0 0-3.387h-17.248a1.693 1.693 0 0 0 0 3.387z"/>
      <path fill="#e35454" d="m82.89 122.69-6.196 21.267c1.424 5.242 4.724 8.292 10.005 8.895 5.68-1.213 9.877-3.604 10.004-8.895l-6.196-21.267 4.725-7.863c.715-4.591-1.86-7.663-8.533-8.855-5.664 2.23-8.283 5.2-8.534 8.855z"/>
      <path fill="#c8c8c8" d="M86.699 105.972c-5.671-2.564-13.408-8.59-16.61-13.156l-8.332 7.125 12.327 22.934c2.13-6.235 6.206-11.907 12.615-16.903z"/>
      <path fill="#c8c8c8" d="M86.699 105.972c5.67-2.564 13.407-8.59 16.609-13.156l8.332 7.125-12.327 22.934c-2.13-6.235-6.206-11.907-12.614-16.903z"/>
      <path fill="#555768" d="M67.913 136.569h3.143A59.14 59.14 0 0 0 86.7 152.852a59.14 59.14 0 0 0 15.642-16.283h3.143v18.52h-37.57z"/>
      <path fill="#41434d" d="M88.392 162.56h-3.387v-10.946l1.694 1.238 1.693-1.238z"/>
    </g>
  </svg>
);

const OPTIONS = [
  {
    id: 'student',
    tag: 'ACADEMIC',
    icon: <StudentSVG />,
    label: 'Student',
    sub: 'Currently enrolled',
    desc: 'Build a strong CV highlighting projects, skills and education.',
    accent: '#8b5cf6',
    accentD: '#A78BFA',
  },
  {
    id: 'fresher',
    tag: 'ENTRY LEVEL',
    icon: <FresherSVG />,
    label: 'Fresher',
    sub: '0–1 year experience',
    desc: 'Craft a compelling first-job resume that gets past ATS filters.',
    accent: '#00C9A7',
    accentD: '#00FFD1',
  },
  {
    id: 'experienced',
    tag: 'PRO',
    icon: <ExperiencedSVG />,
    label: 'Experienced',
    sub: '1+ years in field',
    desc: 'Showcase your career growth with a results-driven professional resume.',
    accent: '#0A66C2',
    accentD: '#4D9FFF',
  },
];

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600;700&display=swap');

.exp-shell { min-height:100vh; font-family:'DM Sans',sans-serif; -webkit-font-smoothing:antialiased; position:relative; overflow:hidden; }
.exp-shell.light { background:#F5F4F8; color:#1A1828; }
.exp-shell.dark  { background:#050508; color:#E8E6F0; }

.exp-orb { position:absolute; border-radius:50%; pointer-events:none; }
.exp-orb-1 { width:600px; height:600px; top:-200px; left:-200px; background:radial-gradient(circle, rgba(139,92,246,0.09) 0%, transparent 65%); }
.exp-orb-2 { width:500px; height:500px; bottom:-150px; right:-100px; background:radial-gradient(circle, rgba(0,201,167,0.08) 0%, transparent 65%); }

.exp-grid {
  position:absolute; inset:0; pointer-events:none; background-size:40px 40px;
  mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
  -webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%, black, transparent);
}
.exp-shell.dark .exp-grid { background-image:linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px); }
.exp-shell.light .exp-grid { background-image:linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px); }

.exp-page {
  position:relative; z-index:1;
  min-height:calc(100vh - 64px); margin-top:64px;
  padding:64px 24px 80px;
  display:flex; flex-direction:column; align-items:center; gap:44px;
}

.exp-header { text-align:center; max-width:600px; }

.exp-badge {
  display:inline-flex; align-items:center; gap:7px;
  font-size:11px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase;
  padding:6px 14px; border-radius:100px; margin-bottom:20px;
}
.exp-shell.dark .exp-badge { background:rgba(139,92,246,0.12); border:1px solid rgba(139,92,246,0.3); color:#A78BFA; }
.exp-shell.light .exp-badge { background:rgba(139,92,246,0.08); border:1px solid rgba(139,92,246,0.2); color:#7C3AED; }

.exp-title {
  font-family:'Syne',sans-serif;
  font-size:clamp(26px,4vw,42px); font-weight:800; letter-spacing:-0.04em; line-height:1.1;
  margin-bottom:14px;
}
.exp-shell.dark .exp-title { color:#F0EEF8; }
.exp-shell.light .exp-title { color:#1A1828; }
.exp-title span {
  background:linear-gradient(135deg,#A78BFA,#00FFD1);
  -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent;
}
.exp-shell.light .exp-title span {
  background:linear-gradient(135deg,#7C3AED,#00C9A7);
  -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent;
}
.exp-sub { font-size:15px; line-height:1.7; }
.exp-shell.dark .exp-sub { color:#6E6B80; }
.exp-shell.light .exp-sub { color:#8B879E; }

.exp-cards { display:grid; grid-template-columns:repeat(3,1fr); gap:20px; width:100%; max-width:900px; }
@media(max-width:700px){ .exp-cards{ grid-template-columns:1fr; max-width:400px; } }

.exp-card {
  border-radius:20px; padding:28px 22px 22px; cursor:pointer; position:relative;
  overflow:hidden; border:1.5px solid; text-align:left; background:none;
  display:flex; flex-direction:column; transition:transform 0.22s, box-shadow 0.22s, border-color 0.22s;
}
.exp-shell.dark .exp-card { background:#0D0D12; border-color:rgba(255,255,255,0.06); }
.exp-shell.light .exp-card { background:#FFFFFF; border-color:rgba(0,0,0,0.08); box-shadow:0 2px 16px rgba(0,0,0,0.05); }

.exp-card:hover { transform:translateY(-6px); }
.exp-shell.dark .exp-card:hover { border-color:var(--ac-d); box-shadow:0 12px 40px color-mix(in srgb, var(--ac-d) 18%, transparent); }
.exp-shell.light .exp-card:hover { border-color:var(--ac); box-shadow:0 12px 40px color-mix(in srgb, var(--ac) 15%, transparent); }
.exp-shell.dark .exp-card.active { border-color:var(--ac-d); box-shadow:0 0 0 3px color-mix(in srgb, var(--ac-d) 18%, transparent); transform:translateY(-6px); }
.exp-shell.light .exp-card.active { border-color:var(--ac); box-shadow:0 0 0 3px color-mix(in srgb, var(--ac) 15%, transparent); transform:translateY(-6px); }

.exp-glow {
  position:absolute; inset:0; border-radius:20px; pointer-events:none; opacity:0;
  transition:opacity 0.35s;
  background:radial-gradient(ellipse at 50% 0%, var(--glow,transparent), transparent 70%);
}
.exp-card:hover .exp-glow, .exp-card.active .exp-glow { opacity:1; }

.exp-card-top { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:16px; }

.exp-card-icon { transition:transform 0.25s; flex-shrink:0; }
.exp-card:hover .exp-card-icon { transform:scale(1.08) translateY(-2px); }

.exp-card-tag {
  font-size:10px; font-weight:700; letter-spacing:0.1em; padding:4px 10px; border-radius:100px;
  align-self:flex-start; margin-top:4px;
}
.exp-shell.dark .exp-card-tag { color:var(--ac-d); background:color-mix(in srgb, var(--ac-d) 12%, transparent); border:1px solid color-mix(in srgb, var(--ac-d) 30%, transparent); }
.exp-shell.light .exp-card-tag { color:var(--ac); background:color-mix(in srgb, var(--ac) 10%, transparent); border:1px solid color-mix(in srgb, var(--ac) 25%, transparent); }

.exp-card-name {
  font-family:'Syne',sans-serif; font-size:20px; font-weight:800;
  letter-spacing:-0.02em; margin-bottom:4px;
}
.exp-shell.dark .exp-card-name { color:#EDEAF5; }
.exp-shell.light .exp-card-name { color:#1A1828; }

.exp-card-sub { font-size:12px; font-weight:500; margin-bottom:12px; }
.exp-shell.dark .exp-card-sub { color:#4A4760; }
.exp-shell.light .exp-card-sub { color:#B0ACC4; }

.exp-divider { height:1px; margin-bottom:14px; }
.exp-shell.dark .exp-divider { background:rgba(255,255,255,0.06); }
.exp-shell.light .exp-divider { background:rgba(0,0,0,0.06); }

.exp-card-desc { font-size:13px; line-height:1.65; margin-bottom:20px; flex:1; }
.exp-shell.dark .exp-card-desc { color:#6E6B80; }
.exp-shell.light .exp-card-desc { color:#8B879E; }

.exp-card-cta {
  width:100%; padding:11px 0; border-radius:10px; border:none;
  font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700;
  cursor:pointer; transition:filter 0.2s, transform 0.15s;
}
.exp-shell.dark .exp-card-cta { background:var(--ac-d); color:#050508; }
.exp-shell.light .exp-card-cta { background:var(--ac); color:#fff; }
.exp-card-cta:hover { filter:brightness(1.08); transform:translateY(-1px); }

.exp-check {
  position:absolute; top:14px; right:14px; width:22px; height:22px; border-radius:50%;
  display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:800;
}
.exp-shell.dark .exp-check { background:var(--ac-d); color:#050508; }
.exp-shell.light .exp-check { background:var(--ac); color:#fff; }

.exp-progress { display:flex; gap:8px; }
.exp-seg { height:5px; width:72px; border-radius:100px; transition:background 0.3s; }
.exp-shell.dark .exp-seg { background:rgba(255,255,255,0.1); }
.exp-shell.light .exp-seg { background:#E5E7EB; }
.exp-seg.on { background:#A78BFA; }
.exp-shell.light .exp-seg.on { background:#7C3AED; }
`;

const StepExperienceLevel = ({ onSelect, onBack, theme, toggleTheme }) => {
  const [selected, setSelected] = useState(null);
  const isDark = (theme || 'dark') === 'dark';

  const handleChoose = (id) => {
    setSelected(id);
    setTimeout(() => {
      onSelect(id);
    }, 120);
  };

  return (
    <>
      <style>{CSS}</style>
      <div className={`exp-shell ${theme || 'dark'}`}>
        <div className="exp-orb exp-orb-1" />
        <div className="exp-orb exp-orb-2" />
        <div className="exp-grid" />

        <TopMenu theme={theme} toggleTheme={toggleTheme} />

        <div className="exp-page">
          <motion.div
            className="exp-header"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="exp-badge">✦ STEP 1 OF 3</div>
            <h1 className="exp-title">
              What's your<br />
              <span>experience level?</span>
            </h1>
            <p className="exp-sub">
              We'll tailor your resume sections to fit your background perfectly.
            </p>
          </motion.div>

          <div className="exp-cards">
            {OPTIONS.map((opt, i) => (
              <motion.div
                key={opt.id}
                className={`exp-card ${selected === opt.id ? 'active' : ''}`}
                style={{
                  '--ac': opt.accent,
                  '--ac-d': opt.accentD,
                  '--glow': isDark
                    ? `color-mix(in srgb, ${opt.accentD} 18%, transparent)`
                    : `color-mix(in srgb, ${opt.accent} 12%, transparent)`,
                }}
                initial={{ opacity: 0, y: 32 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.12 + i * 0.1, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                whileTap={{ scale: 0.985 }}
                onClick={() => handleChoose(opt.id)}
              >
                <div className="exp-glow" />

                <div className="exp-card-top">
                  <div className="exp-card-icon">{opt.icon}</div>
                  <span className="exp-card-tag">{opt.tag}</span>
                </div>

                <div className="exp-card-name">{opt.label}</div>
                <div className="exp-card-sub">{opt.sub}</div>
                <div className="exp-divider" />
                <p className="exp-card-desc">{opt.desc}</p>

                <button
                  className="exp-card-cta"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleChoose(opt.id);
                  }}
                >
                  Select {opt.label} →
                </button>

                {selected === opt.id && (
                  <motion.div
                    className="exp-check"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: 'spring', stiffness: 420, damping: 22 }}
                  >
                    ✓
                  </motion.div>
                )}
              </motion.div>
            ))}
          </div>

          <div className="exp-progress">
            <div className="exp-seg on" />
            <div className="exp-seg" />
            <div className="exp-seg" />
          </div>
        </div>
      </div>
    </>
  );
};

export default StepExperienceLevel;